/*
========================================
PRODUCT PREVIEW

ANIMATIONS

Все анимации блока preview:

- движение центральной картинки
- анимация левой шторки
- анимация правой шторки
- будущие микро-анимации

Все параметры движения настраиваются здесь.

Задача файла:
чтобы визуальные блоки не содержали
логики анимации.

В дальнейшем настройки могут
переноситься в админпанель.
========================================
*/

/*
========================================
PRODUCT PREVIEW

ANIMATIONS

Все анимации блока preview:

- движение центральной картинки
- анимация левой шторки
- анимация правой шторки

Все параметры движения меняются здесь.
========================================
*/

export const PRODUCT_PREVIEW_ANIMATIONS = {
  floatOrganic: "floatOrganic 6.5s ease-in-out infinite",
  panelNudgeLeft: "panelNudgeLeft 1.8s ease-in-out infinite",
  panelNudgeRight: "panelNudgeRight 1.8s ease-in-out infinite",
}

export const productPreviewKeyframes = `
  @keyframes panelNudgeLeft {
    0%,
    100% {
      transform: translateX(calc(-100% + 40px));
    }
    50% {
      transform: translateX(calc(-100% + 46px));
    }
  }

  @keyframes floatOrganic {
    0% {
      transform: translate3d(0px, 0px, 0px) scale(1.02) rotate(0deg);
    }
    20% {
      transform: translate3d(4px, -4px, 0px) scale(1.03) rotate(-0.35deg);
    }
    40% {
      transform: translate3d(-5px, -1px, 0px) scale(1.035) rotate(0.28deg);
    }
    60% {
      transform: translate3d(5px, 3px, 0px) scale(1.028) rotate(-0.22deg);
    }
    80% {
      transform: translate3d(-3px, 5px, 0px) scale(1.032) rotate(0.18deg);
    }
    100% {
      transform: translate3d(0px, 0px, 0px) scale(1.02) rotate(0deg);
    }
  }

  @keyframes panelNudgeRight {
    0%,
    100% {
      transform: translateX(calc(100% - 40px));
    }
    50% {
      transform: translateX(calc(100% - 46px));
    }
  }
`